import React from 'react';
import { useSelector } from 'react-redux';
import { USER_ROLES } from '@pwc/pwc-deals-web-common';
import { getUserRole } from 'common/redux/security/loggedInUser/loggedInUserSlice';
import Separator from '../Separator';
import { getUserTermsAndConditionsHasAccepted } from '../../redux/userTermsAndConditions/userTermsAndConditionsSlice';
import { getProjectId } from '../../../features/project/projectSlice';
import { sanitize } from '../../services/sanitizeService';
import {
  getFooterLoaded,
  getFooterTemplate,
} from '../../redux/termsAndConditions/footerSlice';
import TermsConditionsLinks from './TermsConditionsLinks';
import './Footer.scss';
import { parseFooterText } from './helper.ts';

const Footer = () => {
  const footerLoaded = useSelector(getFooterLoaded);
  const projectId = useSelector(getProjectId);
  const hasAccepted = useSelector(getUserTermsAndConditionsHasAccepted);
  const footerTemplate = useSelector(getFooterTemplate);
  const isPwcUser = useSelector(getUserRole) === USER_ROLES.PWC_USER;
  const shouldShowLinks = hasAccepted || isPwcUser;

  if (!footerLoaded) {
    return null;
  }

  const currentYear = String(new Date().getFullYear());
  const fallbackCopyrightStatement = `<div class="copyright"><p>© ${currentYear} PwC. All rights reserved.</p></div>`;

  const showSubText = Boolean(shouldShowLinks && projectId);
  const templateTokens = {
    showSubText,
    projectId,
    currentYear,
  };

  let interpolatedTemplate;
  try {
    interpolatedTemplate = parseFooterText(footerTemplate, templateTokens);
  } catch (e) {
    // eslint-disable-next-line
    console.error('Unable to parse Footer template', e);
    interpolatedTemplate = fallbackCopyrightStatement;
  }

  return (
    <footer>
      <Separator />
      {shouldShowLinks ? <TermsConditionsLinks /> : null}
      <div
        className="copyright"
        dangerouslySetInnerHTML={{
          __html: sanitize(interpolatedTemplate),
        }}
      />
    </footer>
  );
};
export default Footer;
